/**
 * Shared subscription-status logic.
 * Must stay in sync with the statuses the Stripe webhook writes
 * (functions/src/index.ts) and the guard in createCheckoutSession.
 */

import { SubscriptionSnapshot, SubscriptionStatus } from '@/types';

export const ACTIVE_SUBSCRIPTION_STATUSES: SubscriptionStatus[] = [
  'trialing',
  'active',
  'past_due', // Allow access but show warning
];

export function isActiveStatus(status: unknown): boolean {
  return ACTIVE_SUBSCRIPTION_STATUSES.includes(status as SubscriptionStatus);
}

export function isActiveSubscription(
  subscription: Pick<SubscriptionSnapshot, 'status'> | null | undefined
): boolean {
  return subscription != null && isActiveStatus(subscription.status);
}
